import { APPINSIGHTS_STRINGS } from "../constants/appInsightsStrings";
import { appInsights } from "../services/telemetry/applicationInsightsService";

export const trackEvent = (type, properties = {}) => {
  try {
    // Track the event
    appInsights.trackEvent({
      name: APPINSIGHTS_STRINGS[type] || type,
      properties: properties
    });
  } catch (error) {
    console.warn(`Failed to track event ${type}:`, error);
  }
};
